import { render, staticRenderFns } from "./inviteActivity.vue?vue&type=template&id=510b99ad&scoped=true&"
import script from "./inviteActivity.vue?vue&type=script&lang=js&"
export * from "./inviteActivity.vue?vue&type=script&lang=js&"
import style0 from "./inviteActivity.vue?vue&type=style&index=0&id=510b99ad&scoped=true&lang=css&"
import style1 from "./inviteActivity.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510b99ad",
  null
  
)

export default component.exports